export default "__VITE_ASSET__Dx7UTW2m__"